import React from 'react';
import './MainLayoutContainer.css';

const Navbar = ({children}) => (
    <div className="navbar">
        {children}
    </div>
)

const Sidebar = ({ children }) => (
    <div className="sidebar">
        {children}
    </div>

)

const Content = ({ header, elements}) => (
    <div className="content">
        <div className="content__header">
            {header}
        </div>
        <div className="content__elements">
            {elements}
        </div>
    </div>
)

const MainLayoutContainer = ({navbarContent, sidebarContent, header, elements}) => (
    <div className="main">
        <Navbar>
            {navbarContent}
        </Navbar>
        
        <div className="main__container">
            <Sidebar>
                {sidebarContent}
            </Sidebar>
            
            <Content
                header={header}
                elements={elements}
            />
        </div>
    </div>
);

export default MainLayoutContainer;


// WEBPACK FOOTER //
// ./src/containers/MainLayoutContainer/MainLayoutContainer.js